// This file is deprecated. Please use App.jsx instead.
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { createGlobalStyle, ThemeProvider as StyledThemeProvider } from 'styled-components';
import { ThemeProvider } from './context/ThemeContext';
import { useTheme } from './context/ThemeContext';
import Navbar from './components/layout/Navbar';
import Home from './pages/Home';
import Resume from './pages/Resume';
import Articles from './pages/Articles';
import Poetry from './pages/Poetry';
import Videos from './pages/Videos';

const lightTheme = {
  background: '#f8f9fa',
  text: '#333',
  primary: '#007bff',
  secondary: '#6c757d',
  surface: '#ffffff',
  surfaceText: '#333',
  border: 'rgba(0, 0, 0, 0.1)'
};

const darkTheme = {
  background: '#1a1a1a',
  text: '#ffffff',
  primary: '#4dabf7',
  secondary: '#868e96',
  surface: '#2d2d2d',
  surfaceText: '#ffffff',
  border: 'rgba(255, 255, 255, 0.1)'
};

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
      Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    line-height: 1.6;
    background-color: ${props => props.theme.background};
    color: ${props => props.theme.text};
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  a {
    color: ${props => props.theme.primary};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
`;

const AppContent = () => {
  const { isDarkMode } = useTheme();
  
  return (
    <StyledThemeProvider theme={isDarkMode ? darkTheme : lightTheme}>
      <Router>
        <GlobalStyle />
        <AppContainer>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/poetry" element={<Poetry />} />
            <Route path="/videos" element={<Videos />} />
          </Routes>
        </AppContainer>
      </Router>
    </StyledThemeProvider>
  );
};

function App() {
  return (
    <ThemeProvider>
      <AppContent />
    </ThemeProvider>
  );
}

export default App;
